import { required } from "@vuelidate/validators";
import type { ValidationArgs } from "@vuelidate/core";

export interface ImportTicketIdForm {
  ticketId: string;
}

export function getImportTicketIdFormRules(
  _unusedForm: ImportTicketIdForm,
): ValidationArgs<ImportTicketIdForm> {
  return {
    ticketId: {
      required,
    },
  };
}

export const validationMessages: Record<keyof ImportTicketIdForm, object> = {
  ticketId: {
    required: "The Ticket ID is required",
  },
};

export const fieldLabelsMap: Record<keyof ImportTicketIdForm, string> = {
  ticketId: "Ticket ID",
};
